export default "__VITE_ASSET__6ed3ad62__"